export default "__VITE_ASSET__7ud1u2hY__"